// Missing prices must never look like a free session or a broken "HK$" label.
export function bookingPrice(value, perPerson = false) {
    if (value === null || value === undefined || String(value).trim() === '' || !Number.isFinite(Number(value)) || Number(value) <= 0) {
        return 'Price on request';
    }
    return `HK$${Number(value).toLocaleString('en-HK')}${perPerson ? ' / person' : ''}`;
}
